import { currencyInputUtils } from '../../utils/currencyInput.utils';
var stepsRules = [
    {
        from: 10000,
        to: 390000,
        step: 10000,
    },
    {
        from: 400000,
        to: 480000,
        step: 20000,
    },
    {
        from: 500000,
        to: 550000,
        step: 50000,
    },
    {
        from: 600000,
        to: 900000,
        step: 100000,
    },
    {
        from: 1000000,
        to: 5000000,
        step: 1000000,
    },
];
var stepsOptions = stepsRules.reduce(function (acc, stepChunk) {
    var from = stepChunk.from, to = stepChunk.to, step = stepChunk.step;
    for (var i = from; i <= to; i += step) {
        acc.push({
            value: i,
            label: "".concat(currencyInputUtils.numberToString(i), " \u20AC"),
        });
    }
    return acc;
}, []);
export default {
    stepsOptions: stepsOptions,
    defaultValue: 300000,
    minLoanAmountForRoute1: 80000,
};
